import { render, staticRenderFns } from "./ImgIcon.vue?vue&type=template&id=0aefcb37&scoped=true"
import script from "./ImgIcon.vue?vue&type=script&lang=js"
export * from "./ImgIcon.vue?vue&type=script&lang=js"
import style0 from "./ImgIcon.vue?vue&type=style&index=0&id=0aefcb37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefcb37",
  null
  
)

export default component.exports